import { Prefix } from '@/types'
import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'

export interface BibliographySetDetailVolume {
  prefix: Prefix
  bibliographyId: number
  collectionNo: string // APIで返却されておらず、巻次一覧で表示するわけではないが、ダウンロード処理時、ファイルで使用したいので各行毎に保持させるようにする
  marcNo: string
  bibliographyContentId: number
  volume: string
  volumeNumber: string
  volumeTotal: string
  volumeDateLabel: string
  volumeSpecial: string
  displayContent: string
  continueAndLookCode: SystemCode
  collectionsStatus: SystemCode
  continuationStatusName: string // apiで返却されている値ではないが、別APIで取得した値をテーブル表示に使用する必要がある為設定
  shelfCount: number
  holdingCount: number
  orderCount: number
  reserveCount: number
  revision: number
}

export const defaultBibliographySetDetailVolume = (): BibliographySetDetailVolume => ({
  prefix: Prefix.Real,
  bibliographyId: 0,
  collectionNo: '',
  marcNo: '',
  bibliographyContentId: 0,
  volume: '',
  volumeNumber: '',
  volumeTotal: '',
  volumeDateLabel: '',
  volumeSpecial: '',
  displayContent: '',
  continueAndLookCode: defaultSystemCode(),
  collectionsStatus: defaultSystemCode(),
  continuationStatusName: '',
  shelfCount: 0,
  holdingCount: 0,
  orderCount: 0,
  reserveCount: 0,
  revision: 0
})

export function BibliographySetDetailVolumeFromJSON(
  json: any
): BibliographySetDetailVolume {
  return {
    prefix: json.prefix,
    bibliographyId: exists(json, 'bibliography_id') ? json.bibliography_id : 0,
    collectionNo: exists(json, 'collection_no') ? json.collection_no : '',
    marcNo: exists(json, 'marc_no') ? json.marc_no : '',
    bibliographyContentId: exists(json, 'bibliography_content_id')
      ? json.bibliography_content_id
      : 0,
    volume: exists(json, 'volume') ? json.volume : '',
    volumeNumber: exists(json, 'volume_number') ? json.volume_number : '',
    volumeTotal: exists(json, 'volume_total') ? json.volume_total : '',
    volumeDateLabel: exists(json, 'volume_date_label')
      ? json.volume_date_label
      : '',
    volumeSpecial: exists(json, 'volume_special') ? json.volume_special : '',
    displayContent: exists(json, 'display_content') ? json.display_content : '',
    continueAndLookCode: exists(json, 'continue_and_look_code')
      ? SystemCodeFromJSON(json.continue_and_look_code)
      : defaultSystemCode(),
    collectionsStatus: exists(json, 'collections_status')
      ? SystemCodeFromJSON(json.collections_status)
      : defaultSystemCode(),
    continuationStatusName: '',
    shelfCount: exists(json, 'shelf_count') ? json.shelf_count : 0,
    holdingCount: exists(json, 'holding_count') ? json.holding_count : 0,
    orderCount: exists(json, 'order_count') ? json.order_count : 0,
    reserveCount: exists(json, 'reserve_count') ? json.reserve_count : 0,
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
